import { render, staticRenderFns } from "./foot_modules.vue?vue&type=template&id=18751d65&scoped=true"
import script from "./foot_modules.vue?vue&type=script&lang=js"
export * from "./foot_modules.vue?vue&type=script&lang=js"
import style0 from "./foot_modules.vue?vue&type=style&index=0&id=18751d65&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18751d65",
  null
  
)

export default component.exports